import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var GrayZoneComponent = /** @class */ (function () {
    function GrayZoneComponent(copyService, captureService, headerService, navigationService, parametersService, abreCuentasService, requestService, validationHelperService, bitacoraService, productLoaderService, helperService, postValidate, bioCatchService, channelCommunicatorService, identificationService, adjustEvent, taggingService) {
        this.copyService = copyService;
        this.captureService = captureService;
        this.headerService = headerService;
        this.navigationService = navigationService;
        this.parametersService = parametersService;
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.validationHelperService = validationHelperService;
        this.bitacoraService = bitacoraService;
        this.productLoaderService = productLoaderService;
        this.helperService = helperService;
        this.postValidate = postValidate;
        this.bioCatchService = bioCatchService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.identificationService = identificationService;
        this.adjustEvent = adjustEvent;
        this.taggingService = taggingService;
        this.loadExitScreen = false;
        this.showRate = false;
        this.productsMultiSelcted = [];
        this.RISK_LEVELS = RISK_LEVELS;
        this.productsSelects = [];
        this.isNormalizacion = false;
        this.headerService.show(false, true, true);
        this.channelId = this.channelCommunicatorService.getChannelId();
    }
    GrayZoneComponent.prototype.ngOnInit = function () {
        this.sendTagging('init');
        this.IsMulti = this.abreCuentasService.viewOptionMultiProduct;
        this.prueba = this.copyService.copies.message_grayzone_existent;
        this.screenCopies = {};
        this.screenCopies_title = {};
        var product = this.abreCuentasService.getproductSelected().product_code;
        var productSelected = this.abreCuentasService.getproductSelected();
        var preLoginOnly = this.bioCatchService.isEvidenteCase();
        var isOriginal = this.bioCatchService.isAppCN();
        this.bioCatchService.changeContext(StepBiocatchEnum.oferta, product, isOriginal, preLoginOnly);
        this.product_type = productSelected.product_type;
        this.product_code = productSelected.product_code;
        this.codBizagi = this.abreCuentasService.getSolicitationId();
        if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
            this.amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
                this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
            this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
            this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
            this.amountPco = this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
            var rates = this.requestService.getRates();
            this.rateLiving = rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            this.getRates();
        }
        if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            this.bitacoraService.saveDataInBitacora('offer_pco_zg');
            var resultpc = this.abreCuentasService.getPcoModel();
            var rates = this.requestService.getRates();
            this.rateLiving = rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            this.simulator = this.abreCuentasService.getSimulatorModel();
            this.mes = this.simulator.term;
            this.caseNum = resultpc.solicitation_id;
            this.initial_amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString();
            this.initAmount = this.initial_amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
            this.subtype = this.simulator.product_subtype;
            this.subline = this.simulator.product_name;
            this.codesubline = this.simulator.product_subline;
            this.purchase = this.validationHelperService.ispurchase();
            this.purchasePercent = this.simulator.purchase;
            // To do get Rates for living
            this.getRates();
        }
        // MULTIPRODUCTO
        if (this.product_type === BUSINESS_CONST.MULTI) {
            this.bitacoraService.saveDataInBitacora('offer_pco_zg');
            var resultpc = this.abreCuentasService.getPcoModel();
            this.productsMultiSelcted = this.abreCuentasService.getProductsSelects();
            this.productsMultiSelcted = this.productsMultiSelcted.find(function (item) { return item.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; });
            if (!this.abreCuentasService.haveLoan && this.requestService.getRates()) {
                var rates = this.requestService.getRates();
                this.rateLiving = rates[0].value + "% " + rates[0].type + "  (" + rates[1].value + "% " + rates[1].type + ")";
            }
            else {
                this.rateLiving = this.abreCuentasService.getRatesLoan();
            }
            this.simulator = this.abreCuentasService.getSimulatorModel();
            this.showAmount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
                this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
            this.showAmount = this.showAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
            this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
            this.caseNum = resultpc.solicitation_id;
            // this.valor = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue;
            // To do get Rates for living
            this.getRates();
            if (this.abreCuentasService.haveLoan) {
                this.isDeleteloanByNormalization(resultpc);
            }
        }
        // LIBRANZA
        if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
            this.amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue !== undefined ?
                this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue : ' ';
            this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
            if (!this.abreCuentasService.getProspectResponse().client) {
                this.segment_id = this.abreCuentasService.getinfoInferredIncomes().segment_id;
            }
            this.amountPco = this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
            this.loanBenefits = this.parametersService.getSetting(OpEnum.LOAN_BENEFITS_OFFER);
            this.rateLiving = this.abreCuentasService.getRatesLoan();
            this.showRate = true;
        }
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        this.setCopies(this.product_type);
    };
    GrayZoneComponent.prototype.isDeleteloanByNormalization = function (responsePco) {
        var foundLoan = responsePco.granted_product_multi.find(function (item) { return item.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN; });
        var selectedProdInit = this.abreCuentasService.getProductsSelects();
        if (!foundLoan) {
            this.abreCuentasService.setWasDeleteLoan(true);
            var flow = selectedProdInit.filter(function (item) { return item.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LOAN; });
            this.abreCuentasService.setProductsSelects(flow);
        }
    };
    GrayZoneComponent.prototype.getRates = function () {
        this.taxRates = this.requestService.getRates();
        this.showRate = true;
    };
    GrayZoneComponent.prototype.isGranted = function (product_type) {
        var productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
        var granteds = productsGranted.filter(function (i) { return i.product_type === product_type; });
        return granteds.length > 0;
    };
    GrayZoneComponent.prototype.setCopies = function (product_type) {
        this.screenCopies_title = {
            mailInfo: 'Te enviaremos a tu correo electrónico los documentos requeridos para la solicitud de tu crédito.',
            documentsInfo: "Consulta los <a (click)=\"showRequiredDocuments()\"><u>documentos</u></a>" +
                " que necesitar\u00E1s para realizar esta solicitud.",
            caseLabel: 'Número de caso',
        };
        switch (product_type) {
            case BUSINESS_CONST.PRODUCT_TYPE_REVOLVING:
                this.screenCopies = this.copyService.copies.gray_zone_type_revolving;
                break;
            case BUSINESS_CONST.PRODUCT_TYPE_FREE:
                this.screenCopies = this.copyService.copies.gray_zone_type_free;
                this.options = this.parametersService.getSetting(OpEnum.FREE_CREDIT_CHARACTERISTICS);
                break;
            case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
                this.screenCopies = this.copyService.copies.gray_zone_living;
                this.textApproved = ((this.subtype === 'LEA' && this.codesubline === '03')
                    || (this.subtype === 'HIP' && this.codesubline === '55'))
                    ? this.screenCopies.spanText2 : this.screenCopies.spanText;
                this.showAmount = this.initAmount;
                this.labelValue = this.screenCopies.valor;
                this.options = this.parametersService.getSetting(OpEnum.LIVING_CHARACTERISTICS);
                break;
            case BUSINESS_CONST.MULTI:
                this.screenCopies = this.copyService.copies.gray_zone_multi;
                this.productsMultiSelcted = this.abreCuentasService.getProductsSelects();
                this.productsSelects = this.abreCuentasService.getProductsSelects();
                this.screenCopies.head_description_aux = this.screenCopies.head_description_multi;
                this.productsMultiSelcted = this.productsMultiSelcted.find(function (item) { return item.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; });
                if (this.productsMultiSelcted) {
                    this.mes = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
                    this.initial_amount = this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue.toString();
                    this.initAmount = this.initial_amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').split(/\ /).join('').trim();
                    this.showAmount = this.initAmount;
                }
                break;
            case BUSINESS_CONST.PRODUCT_TYPE_LOAN:
                this.rateLiving = this.abreCuentasService.getRatesLoan();
                this.screenCopies = this.copyService.copies.gray_zone_loan;
                this.productsMultiSelcted = this.abreCuentasService.getproductSelected();
                break;
            default:
                break;
        }
    };
    /**
     * Summary Go to next Step
     */
    GrayZoneComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendTagging('next', 'center', '2');
                        if (!(this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING)) return [3 /*break*/, 9];
                        this.productLoaderService.show(this.copyService.copies.show_offer_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA']); // // Relacionados
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this.postValidate.createClient()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.postValidate.createProducts()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.postValidate.performSolicitation()];
                    case 4:
                        _a.sent();
                        this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['ALTA'])];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.captureService.getChannelComunicator(true).then(function (res2) {
                                if (res2 === '208') {
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
                                }
                                else if (res2 === '20-04') {
                                    res2 = '208';
                                    _this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
                                }
                                (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '127') ?
                                    _this.navigationService.navigateToGeneralInformation(res2) :
                                    _this.navigationService.nextStep(res2);
                                if (_this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
                                    var event_1 = {
                                        eventToken: 'huswfn',
                                        callbackParams: callbackAdjustContratarTC,
                                    };
                                    _this.adjustEvent.adjustTrackEvent(event_1);
                                }
                                _this.bitacoraService.saveDataInBitacora('Out_loading_Product');
                                _this.productLoaderService.hide();
                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        this.navigationService.navigateToGeneralInformation('107');
                        return [3 /*break*/, 8];
                    case 8:
                        this.bitacoraService.saveDataInBitacora('product_accepted_approved');
                        return [2 /*return*/];
                    case 9:
                        this.navigationService.nextStep('200');
                        return [2 /*return*/];
                }
            });
        });
    };
    GrayZoneComponent.prototype.checkRelated = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document, resInfo, bitacoraEvent, pcoStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.continueRelated = true;
                        document = this.abreCuentasService.getDocumentInfo().document_number;
                        return [4 /*yield*/, this.identificationService.validateIfIsRelated(document)];
                    case 1:
                        resInfo = _a.sent();
                        console.log('resInfo');
                        console.log(resInfo);
                        if (!resInfo.related) {
                            return [2 /*return*/];
                        }
                        bitacoraEvent = "employee_members";
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        pcoStatus = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
                        console.log('pcoStatus');
                        console.log(pcoStatus);
                        // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
                        if (pcoStatus !== 'PCO01') {
                            return [2 /*return*/];
                        }
                        this.navigationService.nextStep('203');
                        this.productLoaderService.hide();
                        this.continueRelated = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    GrayZoneComponent.prototype.previous = function () {
        this.sendTagging('prev', 'center', '1');
        this.bitacoraService.saveDataInBitacora('mejor_otro_dia_pco');
        this.navigationService.navigateToGeneralInformation('512');
    };
    GrayZoneComponent.prototype.showRequiredDocuments = function () {
        this.navigationService.nextStep('202');
    };
    GrayZoneComponent.prototype.goExit = function () {
        this.navigationService.nextStep('106');
    };
    GrayZoneComponent.prototype.closeApp = function () {
        this.loadExitScreen = true;
    };
    GrayZoneComponent.prototype.listBenefits = function (row) {
        return this.parametersService.getSetting(row.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? row.options_gray_zone : row.options);
    };
    GrayZoneComponent.prototype.sendTagging = function (value, position, event) {
        var page = '6';
        var extras = {
            object: 'transactionProductCategory',
            value: 'ZonaGris',
            pageValue: 'GrayZone',
        };
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    return GrayZoneComponent;
}());
export { GrayZoneComponent };
